import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BookingService {
  searchType = 'citiesandhotels';
  language: string = 'en';
  searchData: any;
  searchHistory: any;
  destinations: [];
  private dataFiles = {
    'hotels': 'hotels',
    'citiesandhotels': 'citiesandhotels',
    'default': 'all'
  };

  constructor(private http: HttpClient) {
    if (typeof(window) != "undefined") {
      this.searchData = JSON.parse(window.sessionStorage.getItem("searchData")) || {};
      if (window['Scandic'].bookingWidgetLabels && window['Scandic'].bookingWidgetLabels.language)
        this.language = window['Scandic'].bookingWidgetLabels.language;  // language is reqd for date-picker translations
      else {
        const language = window.location.hostname.substr(window.location.hostname.lastIndexOf(".")+1);
        switch (language) {
          case "com":
              this.language = "en";
              break;
          case "se":
              this.language = "sv";
              break;
          case "dk":
              this.language = "da";
              break;
          default:
              this.language = language;
              break;
        }
      }
      this.searchHistory = JSON.parse(window.localStorage.getItem("searchHistory")) || [];
    }
  }

  getSearchData(type: string): any {
    return this.searchData && type ? this.searchData[type] : this.searchData;
  }

  saveSearchData(searchData: any, type: string): void {
    this.searchData[type] = searchData;
    window.sessionStorage.setItem('searchData', JSON.stringify(this.searchData));
    if (type == "search") {
      this.addToSearchHistory(searchData.selectedItem);
    }
  }

  getSavedBookingCode(): any {
    return JSON.parse(window.localStorage.getItem('bookingCode'));
  }

  setSavedBookingCode(data: any): void {
    if (data)
      window.localStorage.setItem('bookingCode', JSON.stringify(data));
    else
      window.localStorage.removeItem('bookingCode');
  }

  getSearchHistory(): any {
    return this.searchHistory && this.searchHistory.length > 0 ? this.searchHistory : null;
  }

  setSearchHistory(): void {
    if (typeof(window) != 'undefined' && this.searchHistory.length > 0) {
      window.localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));
    }
  }

  addToSearchHistory(searchItem: any): void {
    if (!searchItem)
      return;

    const isPresent = this.searchHistory.filter((item) => {
      return item.Id == searchItem.Id;
    });
    if (isPresent.length == 0)
      this.searchHistory.push(searchItem);
    this.setSearchHistory();
  }

  getHotelsAndDestinations(callback: Function): void {
    if (this.destinations) { return; }

    let dataFile = '';
		if (this.searchType === 'hotels' || this.searchType === 'citiesandhotels') {
			dataFile = this.dataFiles[this.searchType];
		} else {
			dataFile = this.dataFiles['default'];
    }

    let url;
    if (typeof window != 'undefined') {
      url = window.location.origin + '/ta/' + dataFile + '-' + this.language;
    }

    if (!!url)
      this.http.get(url, {}).subscribe( (data: []) => {
        data.forEach((item: {}) => {
          let t = item['tokens'].join(' ');
          item['tokens'] = ' ' + <any>t;
          item['matchLevel'] = 0;
          return item;
        });
        this.destinations = <any>data;
        if (typeof(callback) == 'function') {
          callback();
        }
      });
  }

}